import prepareTranslate from '@/helpers/dictionary';
import PropTypes from 'prop-types';
import { FAMILY_STATUS, GENDER } from '@/helpers/enums';
import { formatDate } from '@/helpers/string';
import PageTemplate from '../PageTemplate';
import SectionView from '../SectionView';

function ViewAgentDetails(props) {
  const {
    agent,
  } = props;

  const t = prepareTranslate();

  // TODO: move to agentview functions
  const detailsLines = [
    {
      title: t('components.viewAgentDetails.firstName'),
      value: agent.personalDetails.firstName,
    },
    {
      title: t('components.viewAgentDetails.lastName'),
      value: agent.personalDetails.lastName,
    },
    {
      title: t('components.viewAgentDetails.uid'),
      value: agent.personalDetails.uid,
    },
    {
      title: t('components.viewAgentDetails.gender'),
      value: GENDER.find(({ value: genderValue }) => genderValue === agent.personalDetails.gender)?.label || '',
    },
    {
      title: t('components.viewAgentDetails.dob'),
      value: agent.personalDetails.dob || null,
    },
    {
      title: t('components.viewAgentDetails.familyStatus'),
      value: FAMILY_STATUS.find(({ value: familtStatusValue }) => familtStatusValue === agent.personalDetails.familyStatus)?.label || '',
    },
    {
      title: t('components.viewAgentDetails.spouse'),
      value: agent.personalDetails.spouse,
    },
    {
      title: t('components.viewAgentDetails.numberOfChildren'),
      value: agent.personalDetails.children?.length || '',
    },
  ];

  // TODO: move to agentview functions
  const contactLines = [
    {
      title: t('components.viewAgentDetails.cellphone'),
      value: agent.personalDetails.phone,
    },
    {
      title: t('components.viewAgentDetails.extracellphone'),
      value: agent.personalDetails.extraPhone,
    },
    {
      title: t('components.viewAgentDetails.homephone'),
      value: agent.personalDetails.homePhone,
    },
    {
      title: t('components.viewAgentDetails.officephone'),
      value: agent.personalDetails.officePhone,
    },
    {
      title: t('components.viewAgentDetails.email'),
      value: agent.personalDetails.email,
    },
    {
      title: t('components.viewAgentDetails.homeaddress'),
      value: agent.personalDetails.homeAddress,
    },
    {
      title: t('components.viewAgentDetails.officeaddress'),
      value: agent.personalDetails.officeAddress,
    },
    {
      title: t('components.viewAgentDetails.website'),
      value: agent.personalDetails.website,
    },
  ];

  // TODO: move to agentview functions
  const datesLines = [
    {
      title: t('components.viewAgentDetails.policyend'),
      value: agent.personalDetails.policyEndDate ? formatDate(agent.personalDetails.policyEndDate) : '',
      files: agent.personalDetails?.policyEndDateFiles,
    },
    {
      title: t('components.viewAgentDetails.tax'),
      value: agent.personalDetails.taxDeductionsDate ? formatDate(agent.personalDetails.taxDeductionsDate) : '',
      files: agent.personalDetails.taxDeductionsDateFiles,
    },
    {
      title: t('components.viewAgentDetails.license'),
      value: agent.personalDetails.agentLicenseDate ? formatDate(agent.personalDetails.agentLicenseDate) : '',
      files: agent.personalDetails.agentLicenseDateFile,
    },
  ];

  return (
    <PageTemplate.Panel id='details'>
      <SectionView
        title={t('components.viewAgentDetails.headers.private')}
        lines={detailsLines}
      />
      <SectionView
        title={t('components.viewAgentDetails.headers.contact')}
        lines={contactLines}
      />
      <SectionView
        title={t('components.viewAgentDetails.headers.dates')}
        lines={datesLines}
      />
    </PageTemplate.Panel>
  );
}

ViewAgentDetails.propTypes = {
  agent: PropTypes.object,
};

export default ViewAgentDetails;
